import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Modal,
  Table,
  Badge,
  InputGroup,
  Spinner,
  FormControl,
} from "react-bootstrap";
import axiosInstance from '../../api/axios';
import { toast } from "react-toastify";
// import { FaTrash, FaPencilAlt, FaPlus, FaSearch } from "react-icons/fa";
import { Trash, Pencil, Plus, Search } from "react-bootstrap-icons";
import Select from 'react-select';
import Header from "../../layouts/Header";
import { useSelector } from "react-redux";

const RMSubCategory = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const accessToken = localStorage.getItem("authToken");
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [materialAccess, setMaterialAccess] = useState([]);

    console.log("Access :", access);
    
    useEffect(() => {
      if (Array.isArray(access)) {
        const filteredAccess = access?.filter((perm) =>
          perm?.startsWith("RmSubCategory:")
        );
        setMaterialAccess(filteredAccess);
      }
    }, [access]);

    console.log("Material Access:", materialAccess);
  
    // State for data
    const [subCategories, setSubCategories] = useState([]);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]);
    const [mainCategories, setMainCategories] = useState([]);
  
    // State for forms
    const [formData, setFormData] = useState({
        main_category: "",
        name: "",
        description: "",
    });
  
    const [editFormData, setEditFormData] = useState({
        id: "",
        main_category: "",
        name: "",
        description: "",
    });
  
    // State for UI
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  
    // State for filters and pagination
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedMainCategory, setSelectedMainCategory] = useState(null);

    // Format options for react-select
    const mainCategoryOptions = mainCategories.map(cat => ({
        value: cat._id,
        label: cat.name
    }));

    // API Calls
    const getMainCategories = async () => {
        try {
        const headers = { Authorization: `Bearer ${accessToken}` };
        const response = await axiosInstance.get("masters/rm-main-category/get", { headers });
        
        if (response?.data?.status === true) {
            setMainCategories(response.data.data.categories);
        }
        } catch (error) {
        handleApiError(error, "Failed to fetch main categories");
        }
    };

    const getSubCategories = async (mainCategoryId = null) => {
        try {
            setIsLoading(true);
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("masters/rm-sub-category/get", { headers });
            
            if (response?.data?.status === true) {
                let categories = response?.data?.data?.categories;
                
                // Add main category name to each subcategory
                categories = categories?.map(cat => ({
                    ...cat,
                    mainCategoryName: mainCategories?.find(mc => mc._id === cat?.mainCategory)?.name || 'Unknown'
                }));
                
                // Filter if main category ID provided
                if (mainCategoryId) {
                    categories = categories?.filter(cat => cat?.mainCategory === mainCategoryId);
                }
                
                setSubCategories(categories);
                setFilteredSubCategories(categories);
            }
        } catch (error) {
            handleApiError(error, "Failed to fetch sub categories");
        } finally {
            setIsLoading(false);
        }
    };

    const addSubCategory = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.post(
                "masters/rm-sub-category/add",
                formData,
                { headers }
            );
        
            if (response?.data?.status === true) {
                toast.success(response.data.data.message);
                getSubCategories();
                resetForm();
                setShowAddModal(false);
            }
        } catch (error) {
            handleApiError(error, "Failed to add sub category");
        } finally {
            setIsLoading(false);
        }
    };

  const updateSubCategory = async (e) => {
    e.preventDefault();
    try {
      setIsEditLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.put(
        "masters/rm-sub-category/update",
        editFormData,
        { headers }
      );
      
      if (response?.data?.status === true) {
        toast.success(response.data.data.message);
        getSubCategories();
        setShowEditModal(false);
      }
    } catch (error) {
      handleApiError(error, "Failed to update sub category");
    } finally {
      setIsEditLoading(false);
    }
  };

  const deleteSubCategory = async () => {
    try {
      setIsDeleteLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.delete(
        `masters/rm-sub-category/delete?id=${editFormData.id}`,
        { headers }
      );
      
      if (response?.data?.status === true) {
        toast.success(response.data.data.message);
        getSubCategories();
        setShowDeleteModal(false);
      }
    } catch (error) {
      handleApiError(error, "Failed to delete sub category");
    } finally {
      setIsDeleteLoading(false);
    }
  };

  // Helper functions
  const handleApiError = (error, defaultMessage) => {
    let errorMessage = defaultMessage;
    
    if (error?.response) {
      if (error.response.status === 400) {
        errorMessage = error.response.data.message || error.response.data.title;
      } else if (error.response.status === 403) {
        errorMessage = error.response.data.message || "Forbidden";
      } else if (error.response.status === 404) {
        errorMessage = error.response.data.message || "Resource not found";
      } else if (error.response.status === 406) {
        errorMessage = error.response.data.error?.message || error.response.data.error;
      } else if (error.response.status === 412) {
        errorMessage = error.response.data.data?.message || error.response.data.error;
      } else if (error.response.status === 500) {
        errorMessage = error.response.data.error || "Server error";
      }
    }
    
    toast.error(errorMessage);
  };

  const resetForm = () => {
    setFormData({
      main_category: "",
      name: "",
      description: "",
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selectedOption) => {
    setFormData(prev => ({ 
      ...prev, 
      main_category: selectedOption?.value || "" 
    }));
  };

  const handleEditSelectChange = (selectedOption) => {
    setEditFormData(prev => ({ 
      ...prev, 
      main_category: selectedOption?.value || "" 
    }));
  };

  const handleMainCategoryFilter = (selectedOption) => {
    setSelectedMainCategory(selectedOption?.value || null);
    getSubCategories(selectedOption?.value);
  };

  const handleEditSubCategory = (subCategory) => {
    setEditFormData({
      id: subCategory._id,
      main_category: subCategory.mainCategory,
      name: subCategory.name,
      description: subCategory.description,
    });
    setShowEditModal(true);
  };

  const handleDeleteSubCategory = (subCategory) => {
    setEditFormData({
      id: subCategory._id,
      name: subCategory.name
    });
    setShowDeleteModal(true);
  };

  // Initialize data
  useEffect(() => {
    getMainCategories();
    getSubCategories();
  }, []);

  // Filter subcategories based on search term
  useEffect(() => {
    if (searchTerm) {
      const filtered = subCategories.filter(item => 
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.mainCategoryName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSubCategories(filtered);
    } else {
      setFilteredSubCategories(subCategories);
    }
    setCurrentPage(1);
  }, [searchTerm, subCategories]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSubCategories.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredSubCategories.length / itemsPerPage);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === 'dark' ? 'bg-dark text-white' : 'bg-light'}`}>
                <Container fluid className="bg-white">
                    {/* Header and Filters */}
                    <Row className="mb-4 pt-2 align-items-center">
                        <Col className="d-flex" lg={7}>
                            <h4 className="mb-0 fw-semibold">RAW MATERIAL SUB CATEGORIES</h4>
                            <span className="text-muted ms-2">(Manage your raw material sub categories).</span>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          {(materialAccess?.includes("RmSubCategory:add") || email === 'contact@xpansecafe.com') && (
                            <Button 
                                variant="primary" 
                                onClick={() => setShowAddModal(true)}
                                className="d-flex align-items-center"
                            >
                                <Plus className="me-2" /> Add New Sub Category
                            </Button>
                          )}
                        </Col>
                        <hr className="mt-2 mb-0" />
                    </Row>

                    <Row className="mb-4">
                        <Col md={6}>
                        <InputGroup>
                            <InputGroup.Text>
                                <Search />
                            </InputGroup.Text>
                            <FormControl
                                placeholder="Search sub categories..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </InputGroup>
                        </Col>
                        <Col md={6} className="d-flex justify-content-end">
                        <div style={{ width: '300px' }}>
                            <Select
                            options={mainCategoryOptions}
                            value={mainCategoryOptions.find(opt => opt.value === selectedMainCategory)}
                            onChange={handleMainCategoryFilter}
                            placeholder="Filter by main category"
                            isClearable
                            />
                        </div>
                        </Col>
                    </Row>

                    {/* Sub Categories Table */}
                    <Row>
                        <Col>
                            {isLoading ? (
                                <div className="text-center py-5">
                                    <Spinner animation="border" variant="primary" />
                                </div>
                            ) : (
                                <>
                                    <div className="table-responsive">
                                      {(materialAccess?.includes("RmSubCategory:get") || email === 'contact@xpansecafe.com') && (
                                        <Table striped bordered hover>
                                            <thead className="bg-black text-white">
                                                <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Description</th>
                                                <th>Main Category</th>
                                                {((materialAccess.includes("RmSubCategory:update") || materialAccess.includes("RmSubCategory:delete")) || email === "contact@xpansecafe.com") && (
                                                  <th>Actions</th>
                                                )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems?.length > 0 ? (
                                                currentItems?.map((subCat, index) => (
                                                    <tr key={subCat?._id}>
                                                      <td>{indexOfFirstItem + index + 1}</td>
                                                      <td className="w-25">{subCat?.name}</td>
                                                      <td style={{ fontSize: '12px' }}>{subCat?.description || '-'}</td>
                                                      <td className="text-muted fw-semibold">{subCat?.mainCategoryName || '-'}</td>
                                                      {((materialAccess.includes("RmSubCategory:update") || materialAccess.includes("RmSubCategory:delete")) || email === "contact@xpansecafe.com") && (
                                                        <td>
                                                            <div className="d-flex">
                                                              {(materialAccess?.includes("RmSubCategory:update") || email === 'contact@xpansecafe.com') && (
                                                                <Button 
                                                                    variant="outline-primary" 
                                                                    size="sm" 
                                                                    className="me-2"
                                                                    onClick={() => handleEditSubCategory(subCat)}
                                                                >
                                                                    <Pencil />
                                                                </Button>
                                                              )}
                                                              {(materialAccess?.includes("RmSubCategory:delete") || email === 'contact@xpansecafe.com') && (
                                                                <Button 
                                                                    variant="outline-danger" 
                                                                    size="sm"
                                                                    onClick={() => handleDeleteSubCategory(subCat)}
                                                                >
                                                                    <Trash />
                                                                </Button>
                                                              )}
                                                            </div>
                                                        </td>
                                                      )}
                                                    </tr>
                                                ))
                                                ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No sub categories found</td>
                                                </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                      )}
                                    </div>

                                    {/* Pagination */}
                                    {filteredSubCategories.length > itemsPerPage && (
                                        <div className="d-flex justify-content-between align-items-center mt-1 pb-2">
                                            <div>
                                                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredSubCategories.length)} of {filteredSubCategories.length} entries
                                            </div>
                                            <div>
                                                <Button 
                                                    variant="outline-secondary" 
                                                    size="sm" 
                                                    disabled={currentPage === 1}
                                                    onClick={() => setCurrentPage(currentPage - 1)}
                                                    className="me-2"
                                                >
                                                    Previous
                                                </Button>
                                                <Button 
                                                    variant="outline-secondary" 
                                                    size="sm" 
                                                    disabled={currentPage === totalPages}
                                                    onClick={() => setCurrentPage(currentPage + 1)}
                                                >
                                                    Next
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </Col>
                    </Row>

                    {/* Add Sub Category Modal */}
                    <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg">
                        <Modal.Header closeButton>
                        <Modal.Title>Add New Sub Category</Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={addSubCategory}>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                            <Form.Label>Main Category <span className="text-danger">*</span></Form.Label>
                            <Select
                                options={mainCategoryOptions}
                                value={mainCategoryOptions.find(opt => opt.value === formData.main_category)}
                                onChange={handleSelectChange}
                                isClearable
                                isSearchable
                                placeholder="Select main category"
                                required
                            />
                            </Form.Group>

                            <Form.Group className="mb-3">
                            <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleFormChange}
                                placeholder="Enter sub category name"
                                required
                            />
                            </Form.Group>

                            <Form.Group className="mb-3">
                            <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                name="description"
                                value={formData.description}
                                onChange={handleFormChange}
                                placeholder="Enter description"
                                required
                            />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowAddModal(false)}>
                            Cancel
                            </Button>
                            <Button variant="warning" type="submit" disabled={isLoading}>
                            {isLoading ? (
                                <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                <span className="ms-2">Adding...</span>
                                </>
                            ) : (
                                "Add Sub Category"
                            )}
                            </Button>
                        </Modal.Footer>
                        </Form>
                    </Modal>

                    {/* Edit Sub Category Modal */}
                    <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
                        <Modal.Header closeButton>
                        <Modal.Title>Edit Sub Category</Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={updateSubCategory}>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                            <Form.Label>Main Category <span className="text-danger">*</span></Form.Label>
                            <Select
                                options={mainCategoryOptions}
                                value={mainCategoryOptions.find(opt => opt.value === editFormData.main_category)}
                                onChange={handleEditSelectChange}
                                isClearable
                                isSearchable
                                placeholder="Select main category"
                                required
                            />
                            </Form.Group>

                            <Form.Group className="mb-3">
                            <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={editFormData.name}
                                onChange={handleEditFormChange}
                                placeholder="Enter sub category name"
                                required
                            />
                            </Form.Group>

                            <Form.Group className="mb-3">
                            <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                name="description"
                                value={editFormData.description}
                                onChange={handleEditFormChange}
                                placeholder="Enter description"
                                required
                            />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                            Cancel
                            </Button>
                            <Button variant="warning" type="submit" disabled={isEditLoading}>
                            {isEditLoading ? (
                                <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                <span className="ms-2">Saving...</span>
                                </>
                            ) : (
                                "Save Changes"
                            )}
                            </Button>
                        </Modal.Footer>
                        </Form>
                    </Modal>

                    {/* Delete Confirmation Modal */}
                    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                        <Modal.Header closeButton>
                        <Modal.Title>Confirm Deletion</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        Are you sure you want to delete the sub category <strong>{editFormData.name}</strong>? This action cannot be undone.
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={deleteSubCategory} disabled={isDeleteLoading}>
                            {isDeleteLoading ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                <span className="ms-2">Deleting...</span>
                            </>
                            ) : (
                            "Delete"
                            )}
                        </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default RMSubCategory;